import { createContext, ReactNode, useContext } from 'react';

type UpsellNavigation = {
  navigateToPeakUpsell: () => void;
};

// Mounted by BaseUpsellModal only when the Peak cross-sell is eligible; consumers render nothing when no
// provider is present (see PeakInfoModule).
const UpsellNavigationContext = createContext<UpsellNavigation | undefined>(undefined);

type Props = {
  children: ReactNode;
  navigateToPeakUpsell: () => void;
};

export function UpsellNavigationProvider({ children, navigateToPeakUpsell }: Props) {
  return <UpsellNavigationContext.Provider value={{ navigateToPeakUpsell }}>{children}</UpsellNavigationContext.Provider>;
}

export const useUpsellNavigation = () => useContext(UpsellNavigationContext);
